export default class Avaliado {

    constructor(pessoa={}, tipo={}, lotacao={}) {
        this.pessoa = pessoa;
        this.tipo = tipo;
        this.lotacao = lotacao;
    }
}



// WEBPACK FOOTER //
// ./src/domain/avaliado/index.js